export default __webpack_public_path__ + "static/media/04.83a0e432.jpg";